<template>
  <div>
    <h3 class="page__title">系统消息</h3>

    <div class="page__bd">
      <div class="weui-form-preview" v-for="(itm,key) in billList " :key="key">
        <div class="weui-form-preview__hd left">
            <div class="weui-form-preview__item">
                <span class="weui-form-preview__value" style="font-size:medium">消息ID：{{itm.order_id}}</span>
            </div>
        </div>
        <div class="weui-form-preview__bd">
            <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">账单周期</label>
                <span class="weui-form-preview__value" >{{itm.bill_period}}</span>
            </div>
            <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">账单金额</label>
                <span class="weui-form-preview__value">￥{{fenToCNY(itm.bill_amount)}}</span>
            </div>
            <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">收款方</label>
                <span class="weui-form-preview__value">{{itm.payee_partner_id}}</span>
            </div>
            <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">付款方</label>
                <span class="weui-form-preview__value">{{itm.payer_partner_id}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="itm.billDetailList != null">
                <label class="weui-form-preview__label">备注</label>
                <span class="weui-form-preview__value" v-for="(itmDetail,key) in itm.billDetailList" :key="key">
                  {{itmDetail.create_time}} <br/> {{itmDetail.bill_desc}}
                </span>
            </div>
            <div class="weui-form-preview__item" v-if="itm.pay_flag == 0">
                <label class="weui-form-preview__label">链点余额</label>
                <span class="weui-form-preview__value">
                  {{balanceDataLD.points }}
                </span>
            </div>
        </div>
       
        <div class="weui-form-preview__ft"  v-if="itm.pay_flag == 0" ><!---->
            <a class="weui-form-preview__btn weui-form-preview__btn_default"  @click="ldFirst = !ldFirst " v-if="balanceDataLD.points > 0">
              <input type="checkbox" v-model="ldFirst">勾选则优先使用链点</input>
            </a> 
            
            
            <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="letsPayBack(itm)">去缴费</a>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import 'bootstrap/dist/css/bootstrap.css'
import axios from 'axios'
import wx from 'jweixin-1.6.0';


import {getPoints} from '../graphql/api'

export default {

  data () {
    return {
      billList:[],
      ldFirst:true,
      partnerid : sessionStorage.getItem("partnerid"),
      balanceDataLD:{points:0}
    }
  },
  mounted() {
    this.getBillList();
    
  },
  methods: {
    fenToCNY(fen){
      let prefix = "";
      let res= ""
      let intv = parseInt(fen)

      if(intv < 0) {
        intv = Math.abs(intv); 
        prefix = "-";
      }

      if(intv <= 9){
        res = "0.0"+ ( intv).toString();    
      }else if(intv <= 99){    
        res =  "0."+ ( intv).toString();   
      }else {
        res = intv.toString();

        res = res.substring(0,res.length-2) + "." + res.substring(res.length-2) 
      }
      return prefix+res;

    },
    getBillList(){
      console.log("getBillList")
      let that = this;
      this.ing=true;
      axios.get('/zmomc/billByPartnerId?partnerid='+this.partnerid).then(res  =>  {
        console.log(res.data)  
        if((res.data == null)) {          
          return;
        }    
        that.getBillDetailList(res.data);
      })
    
    },
    getDetail(bill){
      bill.billDetailList=null;
      axios.get('/zmomc/billDetailByBillId?billid='+bill.order_id).then( async res  =>  {
          console.log(res.data)  
          bill.billDetailList = (res.data)        
        })        
    },
    getBillDetailList(billList){
      console.log("getBillDetailList")
      let that = this;
      this.ing=true;
      for(var bill of billList){
        (that.getDetail(bill));
      }
      
      that.billList=billList    

      that.getMyPoints();
      
    
    },
    getMyPoints(){

      let that = this
      let paras = {};

      paras.pid = this.partnerid;
      paras.bd = this.dateStr + " 00:00:00";
      paras.ed = this.dateEndStr + " 23:59:59";
      paras.ls = [1,2];
      paras.lt = [1,2,3,4,8];
      paras.ld = [0,1];

      getPoints(paras)
      // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
      .catch(err=>{
        console.log(err)
      })
      .then(res1=>{
       // alert(1)
        console.info('获取数据=》'+JSON.stringify(res1.data))
        //alert(JSON.stringify(res1.data))
        that.balanceDataLD = res1.data.findPartnerPointsInfo.points;

      })
    },
    letsPayBack(bill) {
      console.log("letsPayBack")
      let that = this;
      
      let paras = {};

      paras.billId = bill.id;
      if(that.ldFirst){
        if(that.balanceDataLD.points >= bill.bill_amount){
          paras.pointsPay = bill.bill_amount;
          paras.amount = 0;
        }else{
          paras.pointsPay = that.balanceDataLD.points;
          paras.amount = bill.bill_amount - that.balanceDataLD.points;
        }
      }else{        
        paras.pointsPay = 0;
        paras.amount = bill.bill_amount;
      }
      paras.payMethod = 1;
      paras.payInfo="";

      axios.post('/customer/omc/payBill', paras)
      .then(function (response) {
        console.log(response);
        that.rspData = response.data

        if(paras.amount > 0)
          that.letsPay();
        

      })
      .catch(function (error) {
        console.log(error);
      });  
    },
    letsPay(){
      console.log("letsPay")
      if(this.rspData.retcode == 0){
        console.log(this.rspData.data.wxJsapiPayRequestInfo)
        let wxJsapiPayRequestInfo = JSON.parse(this.rspData.data.wxJsapiPayRequestInfo);   
        console.log(wxJsapiPayRequestInfo)

        wx.chooseWXPay({
          timestamp: wxJsapiPayRequestInfo.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
          nonceStr: wxJsapiPayRequestInfo.nonceStr, // 支付签名随机串，不长于 32 位
          package: wxJsapiPayRequestInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: wxJsapiPayRequestInfo.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: wxJsapiPayRequestInfo.paySign, // 支付签名
          success: function(res) {
            if(res.errMsg === 'chooseWXPay:ok'){               
              alert('支付成功')
            } else{
              alert('支付失败')
            }
          },
          fail: function(res) {
            alert(JSON.stringify(res))
          },
          cancel: function(res) { 
            alert(JSON.stringify(res))
          }
        });
      }else{
        alert("系统繁忙，请稍后再试.")
      }
    }
  }
}
</script>
<style>
.center{align-content: center;align-self: center;text-align: center;}
.left{align-content: center;align-self: center;text-align: left;}
</style>


// WEBPACK FOOTER //
// src/views/system_message.vue